// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChequesList_inputField__01FCl {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  width: 100%;
  min-width: 150px;
}
td #ChequesList_my-tooltip__vkiTS {
  background-color: rgba(233, 240, 243, 0.9);
  color: black;
}
.ChequesList_inputField__01FCl .ChequesList_placeholder__UnCjQ,
.ChequesList_inputField__01FCl input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 12px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}

.ChequesList_labelAndButtonWrapper__2cuhK {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
  margin-bottom: 2px;
  gap: 10px;
}

.ChequesList_mainWrapper__ZWO4l {
  height: -moz-fit-content;
  height: fit-content;
  padding: 0 10px;
}

.ChequesList_formWrapper__OK0ty {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow-y: scroll;
}

.ChequesList_registrationTitle__wnuo2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 24px;
  max-width: 1080px;
}

.ChequesList_registrationConfigRoot__1UdEk {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px 16px;
}

.ChequesList_titleWrapper__nu1Vg {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.ChequesList_checkboxWraper__TqbNB {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  gap: 8px;
}

.ChequesList_labelCheckBox__6S8CK {
  font-size: 14px;
  font-weight: 500;
}

.ChequesList_labelAndErrorWrapper__4CKmw {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
}

.ChequesList_orgTitleMain__8gC6e {
  font-weight: 600;
}

@media screen and (max-width: 600px) {
  .ChequesList_label-and-error-wrapper__aDCPK {
    margin-top: 10px;
  }
}

.ChequesList_subjectBlockConfigRoot__CuOYe {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  margin-bottom: 12px;
}

.ChequesList_blockConfigRoot__8ag3I {
  background-color: #fff;
  padding-top: 16px;
  gap: 10px;
  width: 100%;
}

.ChequesList_buttonBlock__fvpQP {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  max-width: 100%;
  margin-bottom: 16px;
}

.ChequesList_buttonConfigRoot__5hO5E {
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.ChequesList_formAddButton__f\\+j6v {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.ChequesList_formAddButton__f\\+j6v span {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}

.ChequesList_formAddButton__f\\+j6v img {
  flex-shrink: 0;
}

.ChequesList_formAddButton__f\\+j6v:hover {
  background-color: #f3f7f7;
}

.ChequesList_formButton__-0XCu {
  display: flex;
  flex-direction: row;
  max-width: 100%;
  gap: 8px;
}

.ChequesList_errorLabel__wPC37 {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: rgb(249, 52, 30);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ChequesList_activeButton__CWbEY {
  font-weight: bold;
  font-size: 14px;
  line-height: 125%;
  color: #0c6154;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.ChequesList_wrapperTooltip__2r-1O.ChequesList_wrapperTooltip__2r-1O {
  background-color: transparent;
  padding: 0;
}

.ChequesList_tooltip__v4EL6.ChequesList_tooltip__v4EL6 {
  background-color: #fff;
  border-radius: 8px;
}

.ChequesList_tooltip__v4EL6.ChequesList_tooltip__v4EL6 span {
  color: var(--color-black-500, #577487);
}

.ChequesList_tooltip__v4EL6.ChequesList_tooltip__v4EL6 button span {
  color: var(--color-black-main, #364954);
}

.ChequesList_tooltip__v4EL6.ChequesList_tooltip__v4EL6 button:hover {
  background-color: #45dcc6;
}

.ChequesList_tooltip__v4EL6.ChequesList_tooltip__v4EL6 button:active {
  background-color: #0c6154;
}

.ChequesList_tooltip__v4EL6.ChequesList_tooltip__v4EL6 button:active span {
  color: #fff;
}

.ChequesList_lngButton__LrNay {
  color: #678aa1;
}

.ChequesList_lngActive__bz-Ho {
  color: #55bbeb;
}

:root:root {
  --rt-color-dark: rgb(83, 83, 83);
  --rt-color-white: rgb(255, 255, 255);
}

.ChequesList_wrapperTooltipFilter__tt8EB.ChequesList_wrapperTooltipFilter__tt8EB {
  background-color: #fff;
  color: var(--color-black-main, #364954);
  padding: 8px;
  border-radius: 8px;
}
.ChequesList_mainWrapper__ZWO4l {
  height: -moz-fit-content;
  height: fit-content;
  padding: 0 10px;
}

.ChequesList_formWrapper__OK0ty {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow-y: scroll;
}

.ChequesList_registrationTitle__wnuo2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 24px;
  max-width: 1080px;
}

.ChequesList_registrationConfigRoot__1UdEk {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px 16px;
}

.ChequesList_labelAndButtonWrapper__2cuhK {
  display: flex;

  overflow: visible;
  align-items: center;
  margin-bottom: 2px;
  gap: 10px;
}

.ChequesList_titleWrapper__nu1Vg {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.ChequesList_checkboxWraper__TqbNB {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  gap: 8px;
}

.ChequesList_labelCheckBox__6S8CK {
  font-size: 14px;
  font-weight: 500;
}

.ChequesList_labelAndErrorWrapper__4CKmw {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
}

.ChequesList_orgTitleMain__8gC6e {
  font-weight: 600;
}

@media screen and (max-width: 600px) {
  .ChequesList_label-and-error-wrapper__aDCPK {
    margin-top: 10px;
  }
}

.ChequesList_subjectBlockConfigRoot__CuOYe {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  margin-bottom: 12px;
}

.ChequesList_blockConfigRoot__8ag3I {
  background-color: #fff;
  padding-top: 16px;
  gap: 10px;
  width: 100%;
}

.ChequesList_buttonBlock__fvpQP {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  max-width: 100%;
  margin-bottom: 16px;
}

.ChequesList_buttonConfigRoot__5hO5E {
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.ChequesList_formAddButton__f\\+j6v {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.ChequesList_formAddButton__f\\+j6v span {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}

.ChequesList_formAddButton__f\\+j6v img {
  flex-shrink: 0;
}

.ChequesList_formAddButton__f\\+j6v:hover {
  background-color: #f3f7f7;
}

.ChequesList_formButton__-0XCu {
  display: flex;
  flex-direction: row;
  max-width: 100%;
  gap: 8px;
}

.ChequesList_inputField__01FCl {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(50% - 8px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 0px;
  max-width: calc(33% - 20px);
  /* flex: 1 1 calc(50% - 10px); */
  width: 100%;
  min-width: 150px;
}
.ChequesList_inputField2__FLYeX {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(50% - 8px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  max-width: calc(50% - 20px);
  /* flex: 1 1 calc(50% - 10px); */
  width: 100%;
  min-width: 150px;
}

.ChequesList_inputField1__A0f7H {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(50% - 8px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  /* margin-bottom: 8px; */
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 10px);
  width: 100%;
  min-width: 150px;
}

.ChequesList_inputField3__Ggykb {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 15px);
}

.ChequesList_inputField1__A0f7H .ChequesList_placeholder__UnCjQ,
.ChequesList_inputField1__A0f7H input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 14px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}

.ChequesList_selectField__LIv78 {
  width: 100%;
  height: 48px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 20px);
  padding: 8px;
  margin: 0;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  
}

.ChequesList_inputField__01FCl .ChequesList_placeholder__UnCjQ,
.ChequesList_inputField__01FCl input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 12px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}
.ChequesList_inputField2__FLYeX .ChequesList_placeholder__UnCjQ,
.ChequesList_inputField2__FLYeX input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 12px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}
.ChequesList_inputlabel2__6BhP- {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  width: 100%;
  padding: 20px;
}
.ChequesList_inputlabel2__6BhP- ::placeholder{
  color: red;
}

.ChequesList_inputField__01FCl input:hover {
  border-color: #8ea3b0;
}

.ChequesList_inputField__01FCl input:focus {
  border-color: #0c6154;
  border-width: 1px;
}

.ChequesList_inputField__01FCl input::placeholder {
  color: #a3c0d2;
  font-weight: 400;
  font-size: 14px;
}

.ChequesList_inputField__01FCl input.ChequesList_-error__uMPl\\+ {
  border-color: #ed1e1e;
}

.ChequesList_inputField1__A0f7H input:hover {
  border-color: #8ea3b0;
}

.ChequesList_inputField1__A0f7H input:focus {
  border-color: #0c6154;
  border-width: 1px;
}

.ChequesList_inputField1__A0f7H input::placeholder {
  color: #a3c0d2;
  font-weight: 400;
  font-size: 14px;
}

.ChequesList_inputField1__A0f7H input.ChequesList_-error__uMPl\\+ {
  border-color: #ed1e1e;
}

.ChequesList_buttonForm__j9q5J {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 8px);
}

.ChequesList_errorLabel__wPC37 {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: rgb(249, 52, 30);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ChequesList_labelAndErrorWrapper__4CKmw {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
}

.ChequesList_activeButton__CWbEY {
  font-weight: bold;
  font-size: 14px;
  line-height: 125%;
  color: #0c6154;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.ChequesList_tooltipWrapper__g9XUW {
  position: relative;
  display: inline-block;
  cursor: pointer; 
}

.ChequesList_tooltipText__9JYcE {
  visibility: hidden; 
  width: 150px;
  background-color: rgba(0, 0, 0, 0.75); 
  color: #fff; 
  text-align: center;
  border-radius: 4px; 
  padding: 5px 10px; 
  position: absolute;
  z-index: 10; 
  bottom: 125%; 
  left: 50%;
  transform: translateX(-50%);
  opacity: 0; 
  transition: opacity 0.3s ease-in-out;
  font-size: 12px;
  pointer-events: none; 
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); 
}

.ChequesList_tooltipWrapper__g9XUW:hover .ChequesList_tooltipText__9JYcE {
  visibility: visible;
  opacity: 1;
  position: absolute;
}

.ChequesList_errorIcon__XJk6s {
  color: red; /* Цвет иконки */
  width: 16px; /* Размер иконки */
  height: 13px;
  display: inline-block;
}


`, "",{"version":3,"sources":["webpack://./src/pages/MainScreen/ChequesList.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;;EAEb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;EAChC,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;EAChC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,mBAAmB;;AAErB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,aAAa;AACf;AACA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU,EAAE,gBAAgB;EAC5B,WAAW,EAAE,kBAAkB;EAC/B,YAAY;EACZ,qBAAqB;AACvB","sourcesContent":[".inputField {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  width: 100%;\n  min-width: 150px;\n}\ntd #my-tooltip {\n  background-color: rgba(233, 240, 243, 0.9);\n  color: black;\n}\n.inputField .placeholder,\n.inputField input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 12px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n\n.labelAndButtonWrapper {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  align-items: center;\n  margin-bottom: 2px;\n  gap: 10px;\n}\n\n.mainWrapper {\n  height: fit-content;\n  padding: 0 10px;\n}\n\n.formWrapper {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  overflow-y: scroll;\n}\n\n.registrationTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 24px;\n  max-width: 1080px;\n}\n\n.registrationConfigRoot {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px 16px;\n}\n\n.titleWrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.checkboxWraper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  gap: 8px;\n}\n\n.labelCheckBox {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.labelAndErrorWrapper {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  align-items: center;\n}\n\n.orgTitleMain {\n  font-weight: 600;\n}\n\n@media screen and (max-width: 600px) {\n  .label-and-error-wrapper {\n    margin-top: 10px;\n  }\n}\n\n.subjectBlockConfigRoot {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 16px;\n  margin-bottom: 12px;\n}\n\n.blockConfigRoot {\n  background-color: #fff;\n  padding-top: 16px;\n  gap: 10px;\n  width: 100%;\n}\n\n.buttonBlock {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n  max-width: 100%;\n  margin-bottom: 16px;\n}\n\n.buttonConfigRoot {\n  background-color: #fff;\n  border-radius: 8px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.formAddButton {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  padding: 10px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.formAddButton span {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n  overflow: hidden;\n}\n\n.formAddButton img {\n  flex-shrink: 0;\n}\n\n.formAddButton:hover {\n  background-color: #f3f7f7;\n}\n\n.formButton {\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n  gap: 8px;\n}\n\n.errorLabel {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  color: rgb(249, 52, 30);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.activeButton {\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 125%;\n  color: #0c6154;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.wrapperTooltip.wrapperTooltip {\n  background-color: transparent;\n  padding: 0;\n}\n\n.tooltip.tooltip {\n  background-color: #fff;\n  border-radius: 8px;\n}\n\n.tooltip.tooltip span {\n  color: var(--color-black-500, #577487);\n}\n\n.tooltip.tooltip button span {\n  color: var(--color-black-main, #364954);\n}\n\n.tooltip.tooltip button:hover {\n  background-color: #45dcc6;\n}\n\n.tooltip.tooltip button:active {\n  background-color: #0c6154;\n}\n\n.tooltip.tooltip button:active span {\n  color: #fff;\n}\n\n.lngButton {\n  color: #678aa1;\n}\n\n.lngActive {\n  color: #55bbeb;\n}\n\n:root:root {\n  --rt-color-dark: rgb(83, 83, 83);\n  --rt-color-white: rgb(255, 255, 255);\n}\n\n.wrapperTooltipFilter.wrapperTooltipFilter {\n  background-color: #fff;\n  color: var(--color-black-main, #364954);\n  padding: 8px;\n  border-radius: 8px;\n}\n.mainWrapper {\n  height: fit-content;\n  padding: 0 10px;\n}\n\n.formWrapper {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  overflow-y: scroll;\n}\n\n.registrationTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 24px;\n  max-width: 1080px;\n}\n\n.registrationConfigRoot {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px 16px;\n}\n\n.labelAndButtonWrapper {\n  display: flex;\n\n  overflow: visible;\n  align-items: center;\n  margin-bottom: 2px;\n  gap: 10px;\n}\n\n.titleWrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.checkboxWraper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  gap: 8px;\n}\n\n.labelCheckBox {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.labelAndErrorWrapper {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  align-items: center;\n}\n\n.orgTitleMain {\n  font-weight: 600;\n}\n\n@media screen and (max-width: 600px) {\n  .label-and-error-wrapper {\n    margin-top: 10px;\n  }\n}\n\n.subjectBlockConfigRoot {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 16px;\n  margin-bottom: 12px;\n}\n\n.blockConfigRoot {\n  background-color: #fff;\n  padding-top: 16px;\n  gap: 10px;\n  width: 100%;\n}\n\n.buttonBlock {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n  max-width: 100%;\n  margin-bottom: 16px;\n}\n\n.buttonConfigRoot {\n  background-color: #fff;\n  border-radius: 8px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.formAddButton {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  padding: 10px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.formAddButton span {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n  overflow: hidden;\n}\n\n.formAddButton img {\n  flex-shrink: 0;\n}\n\n.formAddButton:hover {\n  background-color: #f3f7f7;\n}\n\n.formButton {\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n  gap: 8px;\n}\n\n.inputField {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(50% - 8px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 0px;\n  max-width: calc(33% - 20px);\n  /* flex: 1 1 calc(50% - 10px); */\n  width: 100%;\n  min-width: 150px;\n}\n.inputField2 {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(50% - 8px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  max-width: calc(50% - 20px);\n  /* flex: 1 1 calc(50% - 10px); */\n  width: 100%;\n  min-width: 150px;\n}\n\n.inputField1 {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(50% - 8px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  /* margin-bottom: 8px; */\n  flex: 1 1 calc(33% - 10px);\n  width: 100%;\n  min-width: 150px;\n}\n\n.inputField3 {\n  flex: 1 1 calc(25% - 15px);\n}\n\n.inputField1 .placeholder,\n.inputField1 input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 14px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n\n.selectField {\n  width: 100%;\n  height: 48px;\n  flex: 1 1 calc(33% - 20px);\n  padding: 8px;\n  margin: 0;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  \n}\n\n.inputField .placeholder,\n.inputField input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 12px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n.inputField2 .placeholder,\n.inputField2 input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 12px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n.inputlabel2 {\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  width: 100%;\n  padding: 20px;\n}\n.inputlabel2 ::placeholder{\n  color: red;\n}\n\n.inputField input:hover {\n  border-color: #8ea3b0;\n}\n\n.inputField input:focus {\n  border-color: #0c6154;\n  border-width: 1px;\n}\n\n.inputField input::placeholder {\n  color: #a3c0d2;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.inputField input.-error {\n  border-color: #ed1e1e;\n}\n\n.inputField1 input:hover {\n  border-color: #8ea3b0;\n}\n\n.inputField1 input:focus {\n  border-color: #0c6154;\n  border-width: 1px;\n}\n\n.inputField1 input::placeholder {\n  color: #a3c0d2;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.inputField1 input.-error {\n  border-color: #ed1e1e;\n}\n\n.buttonForm {\n  flex: 1 1 calc(33% - 8px);\n}\n\n.errorLabel {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  color: rgb(249, 52, 30);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.labelAndErrorWrapper {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  align-items: center;\n}\n\n.activeButton {\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 125%;\n  color: #0c6154;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.tooltipWrapper {\n  position: relative;\n  display: inline-block;\n  cursor: pointer; \n}\n\n.tooltipText {\n  visibility: hidden; \n  width: 150px;\n  background-color: rgba(0, 0, 0, 0.75); \n  color: #fff; \n  text-align: center;\n  border-radius: 4px; \n  padding: 5px 10px; \n  position: absolute;\n  z-index: 10; \n  bottom: 125%; \n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0; \n  transition: opacity 0.3s ease-in-out;\n  font-size: 12px;\n  pointer-events: none; \n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); \n}\n\n.tooltipWrapper:hover .tooltipText {\n  visibility: visible;\n  opacity: 1;\n  position: absolute;\n}\n\n.errorIcon {\n  color: red; /* Цвет иконки */\n  width: 16px; /* Размер иконки */\n  height: 13px;\n  display: inline-block;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputField": `ChequesList_inputField__01FCl`,
	"my-tooltip": `ChequesList_my-tooltip__vkiTS`,
	"placeholder": `ChequesList_placeholder__UnCjQ`,
	"labelAndButtonWrapper": `ChequesList_labelAndButtonWrapper__2cuhK`,
	"mainWrapper": `ChequesList_mainWrapper__ZWO4l`,
	"formWrapper": `ChequesList_formWrapper__OK0ty`,
	"registrationTitle": `ChequesList_registrationTitle__wnuo2`,
	"registrationConfigRoot": `ChequesList_registrationConfigRoot__1UdEk`,
	"titleWrapper": `ChequesList_titleWrapper__nu1Vg`,
	"checkboxWraper": `ChequesList_checkboxWraper__TqbNB`,
	"labelCheckBox": `ChequesList_labelCheckBox__6S8CK`,
	"labelAndErrorWrapper": `ChequesList_labelAndErrorWrapper__4CKmw`,
	"orgTitleMain": `ChequesList_orgTitleMain__8gC6e`,
	"label-and-error-wrapper": `ChequesList_label-and-error-wrapper__aDCPK`,
	"subjectBlockConfigRoot": `ChequesList_subjectBlockConfigRoot__CuOYe`,
	"blockConfigRoot": `ChequesList_blockConfigRoot__8ag3I`,
	"buttonBlock": `ChequesList_buttonBlock__fvpQP`,
	"buttonConfigRoot": `ChequesList_buttonConfigRoot__5hO5E`,
	"formAddButton": `ChequesList_formAddButton__f+j6v`,
	"formButton": `ChequesList_formButton__-0XCu`,
	"errorLabel": `ChequesList_errorLabel__wPC37`,
	"activeButton": `ChequesList_activeButton__CWbEY`,
	"wrapperTooltip": `ChequesList_wrapperTooltip__2r-1O`,
	"tooltip": `ChequesList_tooltip__v4EL6`,
	"lngButton": `ChequesList_lngButton__LrNay`,
	"lngActive": `ChequesList_lngActive__bz-Ho`,
	"wrapperTooltipFilter": `ChequesList_wrapperTooltipFilter__tt8EB`,
	"inputField2": `ChequesList_inputField2__FLYeX`,
	"inputField1": `ChequesList_inputField1__A0f7H`,
	"inputField3": `ChequesList_inputField3__Ggykb`,
	"selectField": `ChequesList_selectField__LIv78`,
	"inputlabel2": `ChequesList_inputlabel2__6BhP-`,
	"-error": `ChequesList_-error__uMPl+`,
	"buttonForm": `ChequesList_buttonForm__j9q5J`,
	"tooltipWrapper": `ChequesList_tooltipWrapper__g9XUW`,
	"tooltipText": `ChequesList_tooltipText__9JYcE`,
	"errorIcon": `ChequesList_errorIcon__XJk6s`
};
export default ___CSS_LOADER_EXPORT___;
